export default __webpack_public_path__ + "static/media/carouselBG.99d912f3.png";